import { PlaceholdersId, TFComponent } from '@types';
import { WizardMenuPlaceholder } from './wizardMenu';

export const wizardMenu: TFComponent = {
	component: WizardMenuPlaceholder,
	id: PlaceholdersId.wizardMenu,
	name: 'wizardMenu',
};
